<div class="my-3  py-4  px-3  card">
    <form (submit)="refreshParent()">
        <ng-container *ngIf="page === 'products'">
            <div class="row">
                <div class="col">
                    <div class="row">
                        <div class="mb-3 col-6 d-flex flex-column">
                            <label i18n>Robot status</label>
                                <div class="btn-group" role="group" aria-label="Robot status">
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="robotStatusButtonGroup"
                                        id="robotStatusAll"
                                        [value]="'all'"
                                        [(ngModel)]="filter.robotStatus"
                                    >
                                    <label class="btn btn-outline-primary" for="robotStatusAll">
                                        <ng-container i18n>All</ng-container>
                                    </label>

                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="robotStatusButtonGroup"
                                        id="robotStatusActive"
                                        [value]="'active'"
                                        [(ngModel)]="filter.robotStatus"
                                    >
                                    <label class="btn btn-outline-success" for="robotStatusActive">
                                        <ng-container i18n>Active</ng-container>
                                    </label>

                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="robotStatusButtonGroup"
                                        id="robotStatusInactive"
                                        [value]="'inactive'"
                                        [(ngModel)]="filter.robotStatus"
                                    >
                                    <label class="btn btn-outline-danger" for="robotStatusInactive">
                                        <ng-container i18n>Inactive</ng-container>
                                    </label>
                                </div>
                            </div>

                            <div class="mb-3  col-6 d-flex  flex-column">
                                <label i18n>Web aktiv</label>
                                <div class="btn-group" role="group" aria-label="Web aktiv">
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="webActiveButtonGroup"
                                        id="webActiveYes"
                                        [value]="'yes'"
                                        [(ngModel)]="filter.webActive"
                                    >
                                    <label class="btn btn-outline-success" for="webActiveYes">
                                        <ng-container i18n>Yes</ng-container>
                                    </label>

                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="webActiveButtonGroup"
                                        id="webActiveNo"
                                        [value]="'no'"
                                        [(ngModel)]="filter.webActive"
                                    >
                                    <label class="btn btn-outline-danger" for="webActiveNo">
                                        <ng-container i18n>No</ng-container>
                                    </label>

                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="webActiveButtonGroup"
                                        id="webActiveAll"
                                        [value]="'all'"
                                        [(ngModel)]="filter.webActive"
                                    >
                                    <label class="btn btn-outline-primary" for="webActiveAll">
                                        <ng-container i18n>All</ng-container>
                                    </label>
                                </div>
                            </div>

                            <div class="mb-3 col-6 d-flex flex-column">
                                <label i18n>Campaign status</label>
                                <div class="btn-group" role="group" aria-label="Campaign status">
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="campaignStatusButtonGroup"
                                        id="campaignStatusAll"
                                        [value]="'all'"
                                        [(ngModel)]="filter.campaignStatus"
                                    >
                                    <label class="btn btn-outline-primary" for="campaignStatusAll">
                                        <ng-container i18n>All</ng-container>
                                    </label>

                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="campaignStatusButtonGroup"
                                        id="campaignStatusActive"
                                        [value]="'active'"
                                        [(ngModel)]="filter.campaignStatus"
                                    >
                                    <label class="btn btn-outline-success" for="campaignStatusActive">
                                        <ng-container i18n>Active</ng-container>
                                    </label>

                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="campaignStatusButtonGroup"
                                        id="campaignStatusInactive"
                                        [value]="'inactive'"
                                        [(ngModel)]="filter.campaignStatus"
                                    >
                                    <label class="btn btn-outline-danger" for="campaignStatusInactive">
                                        <ng-container i18n>Inactive</ng-container>
                                    </label>
                                </div>
                            </div>

                            <div class="mb-3 col-12 d-flex flex-column">
                                <label i18n>URL Status</label>
                                <div class="btn-group" role="group" aria-label="URL status">
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="urlStatusButtonGroup"
                                        id="urlStatusAll"
                                        [value]="'all'"
                                        [(ngModel)]="filter.urlStatus"
                                    >
                                    <label class="btn btn-outline-primary" for="urlStatusAll">
                                        <ng-container i18n>All</ng-container>
                                    </label>

                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="urlStatusButtonGroup"
                                        id="urlStatusHasCrawlerUrls"
                                        [value]="'hasCrawlerUrls'"
                                        [(ngModel)]="filter.urlStatus"
                                    >
                                    <label class="btn btn-outline-success" for="urlStatusHasCrawlerUrls">
                                        <ng-container i18n>Har tilknyttet Url</ng-container>
                                    </label>

                                    <input
                                        type="radio"
                                        class="btn-check"
                                        name="urlStatusButtonGroup"
                                        id="urlStatusNoCrawlerUrls"
                                        [value]="'noCrawlerUrls'"
                                        [(ngModel)]="filter.urlStatus"
                                    >
                                    <label class="btn btn-outline-danger" for="urlStatusNoCrawlerUrls">
                                        <ng-container i18n>Ingen tilknyttede URL</ng-container>
                                    </label>
                                </div>
                            </div>

                        <div class="mb-3 col-12 d-flex flex-column">
                            <label i18n>Action status</label>
                            <div class="btn-group" role="group" aria-label="Action status">
                                <input
                                    type="radio"
                                    class="btn-check"
                                    name="actionButtonGroup"
                                    id="actionButtonGroupAll"
                                    [value]="'all'"
                                    [(ngModel)]="filter.sendingStatus"
                                >
                                <label class="btn btn-outline-primary" for="actionButtonGroupAll">
                                    <ng-container i18n>All</ng-container>
                                </label>

                                <input
                                    type="radio"
                                    class="btn-check"
                                    name="actionButtonGroup"
                                    id="actionButtonGroupSender"
                                    [value]="'active'"
                                    [(ngModel)]="filter.sendingStatus"
                                >
                                <label class="btn btn-outline-success" for="actionButtonGroupSender">
                                    <ng-container i18n>Sender</ng-container>
                                </label>

                                <input
                                    type="radio"
                                    class="btn-check"
                                    name="actionButtonGroup"
                                    id="actionButtonGroupNotify"
                                    [value]="'notify'"
                                    [(ngModel)]="filter.sendingStatus"
                                >
                                <label class="btn btn-outline-warning" for="actionButtonGroupNotify">
                                    <ng-container i18n>Notifikation</ng-container>
                                </label>
                            </div>
                        </div>

                        <div class="mb-3 col-12 d-flex flex-column">
                            <label i18n>Price category</label>


                            <div class="btn-group" role="group">
                                <input type="radio"
                                       class="btn-check"
                                       [name]="'priceCategoryButtonGroup1'"
                                       [id]="'priceCategoryButtonGroup1'"
                                       [value]="'none'"
                                       [(ngModel)]="filter.selectedPriceCategory"
                                >
                                <label class="btn btn-outline-success " [for]="'priceCategoryButtonGroup1'">
                                    <ng-container i18n>None</ng-container>
                                </label>
                                <input type="radio"
                                       class="btn-check"
                                       [name]="'priceCategoryButtonGroup2'"
                                       [id]="'priceCategoryButtonGroup2'"
                                       [value]="'Billigst'"
                                       [(ngModel)]="filter.selectedPriceCategory"
                                >
                                <label class="btn btn-outline-danger " [for]="'priceCategoryButtonGroup2'">
                                    <ng-container i18n>Cheapest</ng-container>
                                </label>
                                <input type="radio"
                                       class="btn-check"
                                       [name]="'priceCategoryButtonGroup3'"
                                       [id]="'priceCategoryButtonGroup3'"
                                       [value]="'Samme'"
                                       [(ngModel)]="filter.selectedPriceCategory"
                                >
                                <label class="btn btn-outline-secondary " [for]="'priceCategoryButtonGroup3'">
                                    <ng-container i18n>Same</ng-container>
                                </label>
                                <input type="radio"
                                       class="btn-check"
                                       [name]="'priceCategoryButtonGroup4'"
                                       [id]="'priceCategoryButtonGroup4'"
                                       [value]="'Dyrere'"
                                       [(ngModel)]="filter.selectedPriceCategory"
                                >
                                <label class="btn btn-outline-secondary " [for]="'priceCategoryButtonGroup4'">
                                    <ng-container i18n>More expensive</ng-container>
                                </label>
                            </div>

                        </div>

                        <!--                    <div class="mb-3 col-12">-->
                        <!--                        <div class="form-check">-->
                        <!--                            <label class="form-check-label">-->
                        <!--                                <input class="form-check-input" type="checkbox" required-->
                        <!--                                       [(ngModel)]="filter.currentUser"-->
                        <!--                                       name="user"-->
                        <!--                                       (input)="hasChanged()">-->
                        <!--                                Dine produkter-->
                        <!--                            </label>-->
                        <!--                        </div>-->
                        <!--                    </div>-->
                        <div class="mb-3 col-12">
                            <label for="users" class="">Søgeord</label>
                            <input type="text" class=" form-control" id="query" required
                                   [(ngModel)]="filter.query"
                                   name="query">
                        </div>

                    </div>
                </div>

                <div class="col-3">
                    <div class="row">
                        <div class="mb-3 col-6">
                            <label for="minPrice" class="">Min pris</label>
                            <input type="text" class=" form-control" id="minPrice" required
                                   [(ngModel)]="filter.minPrice"
                                   name="minPrice" >
                        </div>
                        <div class="mb-3  col-6">
                            <label for="maxPrice" class="">Max pris</label>
                            <input type="text" class=" form-control" id="maxPrice" required
                                   [(ngModel)]="filter.maxPrice"
                                   name="maxPrice" >
                        </div>
                        <div class="mb-3 col-6">
                            <label for="minPrice" class="">Min afvigelse %</label>
                            <input type="text" class=" form-control" id="minDeviation" required
                                   [(ngModel)]="filter.minDeviation"
                                   name="minPriceminDeviation" >
                        </div>
                        <div class="mb-3  col-6">
                            <label for="maxPrice" class="">Max afvigelse %</label>
                            <input type="text" class=" form-control" id="maxDeviation" required
                                   [(ngModel)]="filter.maxDeviation"
                                   name="maxDeviation" >
                        </div>
                    </div>
                </div>

                <div class="col-4">
                    <div class="mb-3">
                        <label for="users" class="">Bruger</label>
                        <select id="users" class="form-control custom-select " [(ngModel)]="filter.user"
                                name="users" >
                            <option value="0" selected>Vælg en bruger</option>
                            <option *ngFor="let user of users" value="{{user.id}}">{{user.name}}</option>
                        </select>
                    </div>
                    <div class="mb-3">
                        <label for="users" class="">Category</label>
                        <ng-multiselect-dropdown
                            [placeholder]="'All categories'"
                            [settings]="dropdownSettings"
                            [data]="categories"
                            [(ngModel)]="filter.selectedCategories"
                            (ngModelChange)="changedcategorySelect($event)"
                            [ngModelOptions]="{standalone: true}"
                        >
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="mb-3" *ngFor="let variantGroup of variantGroups">
                        <label class="">{{variantGroup.name}}</label>
                        <ng-multiselect-dropdown
                                [placeholder]="'All variants'"
                                [settings]="variantSettings"
                                [data]="variantGroup.variants"
                                [(ngModel)]="filter.selectedVariants[variantGroup.id]"
                                (ngModelChange)="changedVarintSelect($event)"
                                [ngModelOptions]="{standalone: true}"
                        >
                        </ng-multiselect-dropdown>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="page === 'competitors'">
            <div class="mb-3 mt-4">
                <input type="checkbox" class="" id="pending" required [(ngModel)]="filter.pending"
                       name="pending" >
                <label for="pending" class="">Afventer</label>
                <br>
                <input type="checkbox" class="" id="error" required [(ngModel)]="filter.error"
                       name="error" >
                <label for="error" class="">Fejl</label>
            </div>
        </ng-container>

        <div class="row" style="">
            <div class="col-5 d-flex justify-content-between">


            </div>
            <div class="col-4 offset-3 d-flex justify-content-between">
                <button class="btn    btn-danger" (click)="resetFilter()">Reset</button>
                <input class="btn  " type="submit" [ngClass]="{'btn-primary': changed, 'btn-secondary': !changed}"
                       value="Filtrer">
            </div>
        </div>
    </form>


    <div class="row" style="">
        <div class="col-5 d-flex justify-content-between">
            <button class="btn btn-outline-warning" (click)="startSaveConditions(conditionsModal)">Gem søgning som rapport</button>
            <button class="btn btn-outline-warning" (click)="startGetConditions(conditionsIndexModal)">Rapporter</button>

            <ng-template #conditionsIndexModal let-modal>
                <div class="modal-header">
                    <h4 class="modal-title">Rapporter</h4>
                    <button type="button" class="close" aria-label="Close"
                            (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <p *ngIf="!reports" class="text-muted  text-center">Indlæser...</p>

                    <table *ngIf="reports" class="table table-striped align-middle mt-4 table-sm">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Brugere</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let report of reports; let i = index;">
                                <td>
                                    <span *ngIf="editingReport !== report">{{report.name}}</span>

                                    <ng-container *ngIf="editingReport === report">
                                        <input  type="text" class="form-control" [(ngModel)]="report.name" name="report-{{ i }}-name" [disabled]="saving">
                                    </ng-container>
                                </td>
                                <td>
                                    <p *ngIf="report.users.length === 0" class="text-muted">Ingen brugere</p>

                                    <ul class="list-unstyled  mb-0">
                                        <ng-template ngFor let-user [ngForOf]="report.users" let-j="index">
                                            <li>
                                                <span *ngIf="editingReport !== report">{{ user.name }}</span>

                                                <select *ngIf="editingReport === report" class="form-control  custom-select  mb-1" style="width: 80%" [(ngModel)]="user.id" name="report-{{ i }}-users-{{ j }}-id">
                                                    <option value="0" selected>Vælg en bruger</option>
                                                    <option *ngFor="let user of users" value="{{user.id}}">{{user.name}}</option>
                                                </select>

                                                <a *ngIf="editingReport === report" href="javascript:" (click)="report.users.splice(j, 1)" class="text-danger  float-right">Fjern</a>
                                            </li>
                                        </ng-template>
                                    </ul>

                                    <a *ngIf="editingReport === report" href="javascript:" (click)="report.users.push({})" class="text-success  mt-2">Tilføj bruger</a>
                                </td>
                                <td class="text-end">
                                    <button *ngIf="editingReport !== report" (click)="toggleReportEditable(report)" class="btn btn-primary   ms-2">Edit</button>
                                    <button *ngIf="editingReport === report" (click)="saveReportWithoutAssociations(report)" class="btn btn-primary   ms-2" [disabled]="saving">Save</button>
                                    <button *ngIf="report.is_active" (click)="toggleActive(report)" class="btn btn-success   ms-2" [disabled]="saving || editingReport !== report"><i class="fa fa-check"></i></button>
                                    <button *ngIf="!report.is_active" (click)="toggleActive(report)" class="btn btn-danger   ms-2" [disabled]="saving || editingReport !== report"><i class="fa fa-check"></i></button>
                                    <button (click)="loadReport(report)" class="btn btn-success   ms-2">Restore</button>
                                    <button (click)="deleteReport(report)" class="btn btn-danger   ms-2">Delete</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>

            <ng-template #conditionsModal let-modal>
                <div class="modal-header">
                    <h4 class="modal-title">Gem søgning</h4>
                    <button type="button" class="close" aria-label="Close"
                            (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="mt-4">
                        <div class="mb-3">
                            <label for="name">Navn</label>
                            <input type="text" class="form-control" id="name" [(ngModel)]="report.name" name="name">
                        </div>

                        <div class="pb-5">
                            <ng-template ngFor let-user [ngForOf]="report.users" let-i="index">
                                <div class="clearfix  pb-5">
                                    <select class="form-control  custom-select " [(ngModel)]="user.id"
                                            name="report-{{ i }}-user">
                                        <option [ngValue]="null">-- Vælg en bruger --</option>
                                        <option *ngFor="let user of users"
                                                [ngValue]="user.id">{{user.name}}</option>
                                    </select>

                                    <button (click)="report.users.splice(i, 1)"
                                            class="btn    btn-danger  float-right">Fjern
                                    </button>
                                </div>
                            </ng-template>

                            <button (click)="report.users.push({id: null})"
                                    class="btn    btn-success  float-right">Tilføj bruger
                            </button>
                        </div>

                        <input type="button" value="Gem søgning" (click)="saveReport()"
                               class="btn  btn-primary  float-right" id="edit">
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
